export enum SUBSCRIPTION_STATUS {
  DEACTIVATED = 'DEACTIVATED',
  ACTIVATED = 'ACTIVATED',
  PENDING = 'PENDING',
}
